import script from "./mainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./mainLayout.vue?vue&type=script&setup=true&lang=js"

import "./mainLayout.vue?vue&type=style&index=0&id=584609fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584609fe"]])

export default __exports__